import request from '@/utils/request'
const BASE_URL = '/Account'

export default {
    list(data) {
        return request({
            url: BASE_URL + '/List',
            method: 'post',
            data
        })
    },
    info(id) {
        return request({
            url: BASE_URL + '/Info',
            method: 'get',
            params: { id }
        })
    },
    save(data) {
        return request({
            url: BASE_URL + '/Save',
            method: 'post',
            data
        })
    },
    refund(data) {
        return request({
            url: BASE_URL + '/Refund',
            method: 'post',
            data
        })
    },
    delete(data) {
        return request({
            url: BASE_URL + '/Delete',
            method: 'post',
            data
        })
    },
    getStat(params) {
        return request({
            url: BASE_URL + '/GetStat',
            method: 'get',
            params
        })
    },
    getWorkbenchStat() {
        return request({
            url: BASE_URL + '/GetWorkbenchStat',
            method: 'get',
        })
    },
    import: "/api" + BASE_URL + "/Import",
    // importPhoto: "/api" + BASE_URL + "/ImportPhoto",
    export (data) {
        return request({
            url: BASE_URL + '/Export',
            method: 'post',
            responseType: 'blob',
            data
        }).then(res => {
            var file = res.data;
            var disposition = res.headers['content-disposition'];
            // console.log('disposition', disposition);

            var fileName = "导出";
            if (disposition.lastIndexOf("filename*=UTF-8''") != -1) {
                var text = disposition.substr(disposition.lastIndexOf("filename*=UTF-8''") + ("filename*=UTF-8''").length)
                fileName = decodeURI(text);
            }

            if (navigator.msSaveBlob) {
                // IE10+下载
                navigator.msSaveBlob(file, fileName);
            } else {
                const elink = document.createElement("a");
                elink.download = fileName;
                elink.style.display = "none";
                elink.target = "_blank";
                elink.href = URL.createObjectURL(file);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
            }
            return Promise.resolve();
        });
    }
}